// extracted by mini-css-extract-plugin
export var dropdownButton = "_46-0";
export var fullWidthDropdownButton = "_46-1";
export var icon = "_46-3";
export var iconPlaceholder = "_46-2";
export var menuItemRow = "_46-8";
export var separator = "_46-c";
export var shortcutContainer = "_46-7";
export var shortcutIconLg = "_46-6";
export var shortcutIconMd = "_46-5";
export var shortcutIconSm = "_46-4";
export var submenuChevron = "_46-b";
export var submenuDropdown = "_46-9";
export var submenuTriggerRow = "_46-a";